import { effectiveProfileTags } from '../services/profile'
export function isStaffUser(user) {
	const tags = effectiveProfileTags(user)
	return tags.some(tag =>
		typeof tag?.name === 'string'
		&& tag.name.toLowerCase().startsWith('staff')
	)
}
